<div class="lg:hidden p-1">
  <p-table
    #mobileTable
    [value]="sortedNotes"
    [resizableColumns]="true"
    columnResizeMode="expand"
    stateStorage="local"
    [stateKey]="mobileTableStateKey"
    styleClass="notes-list-table p-datatable-sm p-datatable-gridlines text-[var(--textColor)] bg-primary"
    tableStyleClass="w-full"
    (onColResize)="onColumnResizeEnd()"
  >
    <ng-template pTemplate="header">
      <tr class="border-1 !border-black">
        <th pResizableColumn class="cursor-pointer" [class.!cursor-default]="isSelectMode" (click)="!isSelectMode && sortData('Link')">
          {{ isSelectMode ? 'Select' : 'Links' }}
          <span *ngIf="sortBy === 'Link' && !isSelectMode" class="material-icons text-xs align-middle">
            {{ sortOrder === 'asc' ? 'arrow_upward' : 'arrow_downward' }}
          </span>
        </th>
        <th pResizableColumn class="cursor-pointer" (click)="sortData('Title')" (dblclick)="onHeaderDoubleClick('Title')">
          Title
          <span *ngIf="sortBy === 'Title'" class="material-icons text-xs align-middle">
            {{ sortOrder === 'asc' ? 'arrow_upward' : 'arrow_downward' }}
          </span>
        </th>
        <th pResizableColumn class="cursor-pointer" (click)="sortData('Modified')" (dblclick)="onHeaderDoubleClick('Modified')">
          Modified
          <span *ngIf="sortBy === 'Modified'" class="material-icons text-xs align-middle">
            {{ sortOrder === 'asc' ? 'arrow_upward' : 'arrow_downward' }}
          </span>
        </th>
        <th pResizableColumn class="cursor-pointer" (click)="sortData('Tags')" (dblclick)="onHeaderDoubleClick('Tags')">
          Tags
          <span *ngIf="sortBy === 'Tags'" class="material-icons text-xs align-middle">
            {{ sortOrder === 'asc' ? 'arrow_upward' : 'arrow_downward' }}
          </span>
        </th>
        <th pResizableColumn class="cursor-pointer" (click)="sortData('Size')" (dblclick)="onHeaderDoubleClick('Size')">
          Size
          <span *ngIf="sortBy === 'Size'" class="material-icons text-xs align-middle">
            {{ sortOrder === 'asc' ? 'arrow_upward' : 'arrow_downward' }}
          </span>
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-note>
      <tr
        class="hover:bg-primary-400 dark:hover:!bg-slate-700 dark:hover:!text-slate-100 cursor-pointer bg-primary-100 dark:bg-slate-800 text-black dark:text-slate-100"
        (click)="clickRow(note)"
        [ngClass]="{
          'bg-[var(--project4Color)]': note.ProjectName === 'Work',
          'bg-[var(--project1Color)]': note.ProjectName === 'NotesApp',
          'bg-[var(--project2Color)]': note.ProjectName === 'Vivi/Olivia',
          'bg-[var(--project3Color)]': note.ProjectName === 'Shopping',
          'font-bold': note.Status === 'Next Action',
          'italic text-[var(--textColorFaded)]':
            note.Status === 'Completed' ||
            note.Status === 'Obsolete' ||
            note.Status === 'Cancelled' ||
            note.Status === 'Expired',
          'ring-2 ring-primary-600': isNoteSelected(note._id)
        }"
      >
        <td class="border border-[var(--borderColor)] text-center">
          <ng-container *ngIf="!isSelectMode; else selectModeMobile">
            <button
              type="button"
              class="inline-flex items-center justify-center p-1 text-slate-700 hover:text-blue-600 cursor-pointer"
              (click)="navigateToEdit(note); $event.stopPropagation()"
              aria-label="Edit note"
              title="Edit note"
            >
              <span class="material-icons text-base leading-none">edit</span>
            </button>
          </ng-container>
          <ng-template #selectModeMobile>
            <p-checkbox
              [binary]="true"
              [ngModel]="isNoteSelected(note._id)"
              (ngModelChange)="toggleSelection(note, $event)"
              styleClass="cursor-pointer"
            ></p-checkbox>
          </ng-template>
        </td>
        <td class="border border-[var(--borderColor)]"
          [ngClass]="{
            '!text-gray-400 dark:!text-gray-500': note.Status === 'Completed' || note.Status === 'Expired' || note.Status === 'Obsolete' || note.Status === 'Cancelled',
            'line-through': note.Status === 'Obsolete' || note.Status === 'Cancelled',
            '!line-through text-red-600': note.syncStatus === 'deleted',
            '!text-red-500': note.syncStatus !== 'synced' && note.syncStatus !== 'deleted'
          }"
          [title]="note.syncStatus && note.syncStatus !== 'synced' ? 'Not yet synced to server' : ''">{{ note.Title }}<span *ngIf="isFavoriteNote(note)" title="Favorite"> ❤️</span><span *ngIf="note.Attachments?.length" title="Has attachments"> 📎</span></td>
        <td class="border border-[var(--borderColor)]">{{ formatDate(note.last_modified) }}</td>
        <td class="border border-[var(--borderColor)] max-w-0">
          <div class="flex flex-nowrap gap-1 overflow-x-auto">
            <span
              *ngFor="let tag of getTagDisplayItems(note)"
              class="note-tag-chip inline-flex flex-shrink-0 items-center gap-1 rounded-full border border-[var(--borderColor)] dark:border-slate-600 bg-white dark:bg-slate-800 px-2 py-0.5 text-xs text-[var(--textColor)] dark:text-slate-100 whitespace-nowrap">
              <span
                class="h-2.5 w-2.5 rounded-full border border-black/10 flex-shrink-0"
                [style.backgroundColor]="tag.color || '#94a3b8'"
                [title]="tag.color || 'No tag color'">
              </span>
              <span>{{ tag.name }}</span>
            </span>
          </div>
        </td>
        <td class="border border-[var(--borderColor)] whitespace-nowrap">{{ getNoteSize(note) }} KB</td>
      </tr>
    </ng-template>
  </p-table>
</div>

<!-- Large Screen View -->
<div class="hidden lg:block p-1">
  <p-table
    #desktopTable
    [value]="sortedNotes"
    [resizableColumns]="true"
    columnResizeMode="expand"
    stateStorage="local"
    [stateKey]="desktopTableStateKey"
    styleClass="notes-list-table p-datatable-sm p-datatable-gridlines text-[var(--textColor)] bg-primary border border-black rounded-md"
    tableStyleClass="w-full"
    (onColResize)="onColumnResizeEnd()"
  >
    <ng-template pTemplate="header">
      <tr>
        <th pResizableColumn class="border border-black cursor-pointer" [class.!cursor-default]="isSelectMode" (click)="!isSelectMode && sortData('Link')">
          {{ isSelectMode ? 'Select' : 'Links' }}
          <span *ngIf="sortBy === 'Link' && !isSelectMode" class="material-icons text-xs align-middle">
            {{ sortOrder === 'asc' ? 'arrow_upward' : 'arrow_downward' }}
          </span>
        </th>
        <th pResizableColumn class="border border-black cursor-pointer" (click)="sortData('Title')" (dblclick)="onHeaderDoubleClick('Title')">
          Title
          <span *ngIf="sortBy === 'Title'" class="material-icons text-xs align-middle">
            {{ sortOrder === 'asc' ? 'arrow_upward' : 'arrow_downward' }}
          </span>
        </th>
        <th pResizableColumn class="border border-black cursor-pointer" (click)="sortData('Modified')" (dblclick)="onHeaderDoubleClick('Modified')">
          Modified
          <span *ngIf="sortBy === 'Modified'" class="material-icons text-xs align-middle">
            {{ sortOrder === 'asc' ? 'arrow_upward' : 'arrow_downward' }}
          </span>
        </th>
        <th pResizableColumn class="border border-black cursor-pointer" (click)="sortData('Tags')" (dblclick)="onHeaderDoubleClick('Tags')">
          Tags
          <span *ngIf="sortBy === 'Tags'" class="material-icons text-xs align-middle">
            {{ sortOrder === 'asc' ? 'arrow_upward' : 'arrow_downward' }}
          </span>
        </th>
        <th pResizableColumn class="border border-black cursor-pointer" (click)="sortData('Size')" (dblclick)="onHeaderDoubleClick('Size')">
          Size
          <span *ngIf="sortBy === 'Size'" class="material-icons text-xs align-middle">
            {{ sortOrder === 'asc' ? 'arrow_upward' : 'arrow_downward' }}
          </span>
        </th>
        <th pResizableColumn class="border border-black cursor-pointer" (click)="sortData('Status')" (dblclick)="onHeaderDoubleClick('Status')">
          Status
          <span *ngIf="sortBy === 'Status'" class="material-icons text-xs align-middle">
            {{ sortOrder === 'asc' ? 'arrow_upward' : 'arrow_downward' }}
          </span>
        </th>
        <th pResizableColumn class="border border-black cursor-pointer" (click)="sortData('Type')" (dblclick)="onHeaderDoubleClick('Type')">
          Type
          <span *ngIf="sortBy === 'Type'" class="material-icons text-xs align-middle">
            {{ sortOrder === 'asc' ? 'arrow_upward' : 'arrow_downward' }}
          </span>
        </th>
        <th pResizableColumn id="id-column" class="border border-black cursor-pointer" (click)="sortData('ID')" (dblclick)="onHeaderDoubleClick('ID')">
          ID
          <span *ngIf="sortBy === 'ID'" class="material-icons text-xs align-middle">
            {{ sortOrder === 'asc' ? 'arrow_upward' : 'arrow_downward' }}
          </span>
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-note>
      <tr
        class="hover:bg-primary-400 dark:hover:!bg-slate-700 dark:hover:!text-slate-100 cursor-pointer bg-primary-100 dark:bg-slate-800 text-black dark:text-slate-100"
        (click)="clickRow(note)"
        [ngClass]="{
          'bg-[var(--project4Color)]': note.ProjectName === 'Work',
          'bg-[var(--project1Color)]': note.ProjectName === 'NotesApp',
          'bg-[var(--project2Color)]': note.ProjectName === 'Vivi/Olivia',
          'bg-[var(--project3Color)]': note.ProjectName === 'Shopping',
          'font-bold': note.Status === 'Next Action',
          'italic text-[var(--textColorFaded)]':
            note.Status === 'Completed' ||
            note.Status === 'Obsolete' ||
            note.Status === 'Cancelled' ||
            note.Status === 'Expired',
          'ring-2 ring-primary-600': isNoteSelected(note._id)
        }"
      >
        <td class="border border-[var(--borderColor)] text-center">
          <ng-container *ngIf="!isSelectMode; else selectModeDesktop">
            <button
              type="button"
              class="inline-flex items-center justify-center p-1 text-slate-700 hover:text-blue-600 cursor-pointer"
              (click)="navigateToEdit(note); $event.stopPropagation()"
              aria-label="Edit note"
              title="Edit note"
            >
              <span class="material-icons text-base leading-none">edit</span>
            </button>
            <a
              class="inline-flex items-center justify-center p-1 text-slate-700 hover:text-emerald-600 cursor-pointer"
              [routerLink]="['/view', note._id]"
              target="_blank"
              rel="noopener"
              (click)="$event.stopPropagation()"
              aria-label="View note"
              title="View note"
            >
              <span class="material-icons text-base leading-none">visibility</span>
            </a>
          </ng-container>
          <ng-template #selectModeDesktop>
            <p-checkbox
              [binary]="true"
              [ngModel]="isNoteSelected(note._id)"
              (ngModelChange)="toggleSelection(note, $event)"
              styleClass="cursor-pointer"
            ></p-checkbox>
          </ng-template>
        </td>
        <td class="border border-[var(--borderColor)]"
          [ngClass]="{
            '!text-gray-400 dark:!text-gray-500': note.Status === 'Completed' || note.Status === 'Expired' || note.Status === 'Obsolete' || note.Status === 'Cancelled',
            'line-through': note.Status === 'Obsolete' || note.Status === 'Cancelled',
            '!line-through text-red-600': note.syncStatus === 'deleted',
            '!text-red-500': note.syncStatus !== 'synced' && note.syncStatus !== 'deleted'
          }"
          [title]="note.syncStatus && note.syncStatus !== 'synced' ? 'Not yet synced to server' : ''">{{ note.Title }}<span *ngIf="isFavoriteNote(note)" title="Favorite"> ❤️</span><span *ngIf="note.Attachments?.length" title="Has attachments"> 📎</span></td>
        <td class="border border-[var(--borderColor)]">{{ formatDate(note.last_modified) }}</td>
        <td class="border border-[var(--borderColor)] max-w-0">
          <div class="flex flex-nowrap gap-1 overflow-x-auto">
            <span
              *ngFor="let tag of getTagDisplayItems(note)"
              class="note-tag-chip inline-flex flex-shrink-0 items-center gap-1 rounded-full border border-[var(--borderColor)] dark:border-slate-600 bg-white dark:bg-slate-800 px-2 py-0.5 text-xs text-[var(--textColor)] dark:text-slate-100 whitespace-nowrap">
              <span
                class="h-2.5 w-2.5 rounded-full border border-black/10 flex-shrink-0"
                [style.backgroundColor]="tag.color || '#94a3b8'"
                [title]="tag.color || 'No tag color'">
              </span>
              <span>{{ tag.name }}</span>
            </span>
          </div>
        </td>
        <td class="border border-[var(--borderColor)] whitespace-nowrap">{{ getNoteSize(note) }} KB</td>
        <td class="border border-[var(--borderColor)]">{{ note.Status }}</td>
        <td class="border border-[var(--borderColor)]">{{ note.NoteType }}</td>
        <td id="id-column" class="border border-[var(--borderColor)]">{{ note._id }}</td>
      </tr>
    </ng-template>
  </p-table>
</div>
